var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    role: "presentation",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6c2.579 0 4.15 1.492 4.245 4.005 2.514.095 4.005 1.67 4.005 4.245 0 2.576-1.491 4.14-4 4.24v-1.507c1.652-.085 2.5-.997 2.5-2.733 0-1.825-.925-2.75-2.75-2.75h-1.25v-1.25c0-1.824-.925-2.75-2.75-2.75s-2.75.926-2.75 2.75v1.25H8c-1.825 0-2.75.925-2.75 2.75 0 1.736.847 2.648 2.5 2.733v1.508c-2.509-.099-4-1.663-4-4.241 0-2.579 1.491-4.15 4.004-4.245C7.85 7.492 9.421 6 12 6Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.885 14.72-1.05 1.071-1.092-1.07v3.77h-1.5v-3.762l-1.075 1.06-1.053-1.067 2.876-2.839 2.894 2.837Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.ecadc15bb4d99048802fb277e6060f3c.svg";
export { ForwardRef as ReactComponent };